import {Navigate, Outlet, useLocation} from "react-router-dom";

import PageLoader from "../PageLoader";

import useAuth from "../../hooks/useAuth";

const PrivateRoute = () => {
    const {isLogin, token} = useAuth();
    const location = useLocation()

    if(!isLogin && token) {
        return <PageLoader />
    }

    if(!isLogin) {
        return <Navigate to="/" state={{from: location}} />
    }

    return <Outlet />
}

export default PrivateRoute;
